import { memo } from 'react';

import ValidationFilledIconSVG from '@/assets/validation-filled-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IValidationFilledIcon = (props: Omit<IconProps, 'SVGComponent'>) => (
  <Icon SVGComponent={ValidationFilledIconSVG} {...props} />
);

export const ValidationFilledIcon = memo(IValidationFilledIcon) as typeof IValidationFilledIcon;
